<script>
export default {
  name: 'OrderPrice',
  props: {
    productsCart: {
      type: Object,
      required: true
    },
    deliveryAddress: String
  },
  computed: {
    getPriceHt () {
      return (this.getPrice / 1.2).toFixed(2) ?? 0
    },
    getPrice () {
      return this.productsCart.reduce((sum, product) => {
        return sum + product.products.price * product.quantity
      }, 0)
    },
    getTaxe () {
      return (this.getPrice - this.getPriceHt).toFixed(2) ?? 0
    }
  },
  methods: {
    submit () {
      this.emitter.emit('submit-order', this.$route.query.deliveryAddress)
    }
  }
}
</script>

<template>
  <div class="mt-6 w-full space-y-6 sm:mt-8 lg:mt-0 lg:max-w-xs xl:max-w-md">
    <div class="flow-root">
      <div class="-my-3 divide-y divide-gray-200 dark:divide-gray-800">
        <dl class="flex items-center justify-between gap-4 py-3">
          <dt class="text-base font-normal text-gray-500 dark:text-gray-400">
            Sous-total
          </dt>
          <dd class="text-base font-medium text-gray-900 dark:text-white">
            {{ getPriceHt }} €
          </dd>
        </dl>

        <dl class="flex items-center justify-between gap-4 py-3">
          <dt class="text-base font-normal text-gray-500 dark:text-gray-400">
            Taxes
          </dt>
          <dd class="text-base font-medium text-gray-900 dark:text-white">
            {{ getTaxe }} €
          </dd>
        </dl>

        <dl class="flex items-center justify-between gap-4 py-3">
          <dt class="text-base font-bold text-gray-900 dark:text-white">
            Total
          </dt>
          <dd class="text-base font-bold text-gray-900 dark:text-white">
            {{ getPrice }} €
          </dd>
        </dl>
      </div>
    </div>

    <div class="space-y-3">
      <button v-if="$route.name === 'order_checkout'" @click="$router.push({name: 'order_summary', query: { deliveryAddress: deliveryAddress }})" class="flex w-full items-center justify-center rounded-lg bg-primary-700 px-5 py-2.5 text-sm font-medium text-white hover:bg-primary-800 focus:outline-none focus:ring-4  focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
        Valider les informations
      </button>
      <button v-else @click="submit" class="flex w-full items-center justify-center rounded-lg bg-primary-700 px-5 py-2.5 text-sm font-medium text-white hover:bg-primary-800 focus:outline-none focus:ring-4  focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">
        Procéder au paiement
      </button>
    </div>
  </div>
</template>
